import * as R from "ramda";
import React, {Component} from "react";
import FlexView from "react-flexview";
import SortableTree from "react-sortable-tree";
import ModalContainer from "../../../modules/commons/ModalContainer";
import SimpleButton from "../../../modules/commons/SimpleButton";
import SimpleLoadingOverlay from "../../../modules/popup/SimpleLoadingOverlay";
import SimpleModal from "../../../modules/popup/SimpleModal";
import Api from "../../../Services/Api";
import {HttpStatus, Status} from "../../common/Constants";
import {fetchDataAsync} from "../../../Services/Utils";

class AccessMenuSettingTree extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            masterMenuData: [],
        };
    }

    componentDidMount() {
        this.fetchData();
    }

    fetchData = async () => {
        this.setState((prevValue) => ({...prevValue, loading: true}));
        try {
            const responses = await Promise.all([
                Api.create("NAGAMAS_AUTH").getAllMasterMenu(),
                Api.create("NAGAMAS_AUTH").getMasterRoleMenuById(this.props.data.id),
            ]);

            if (responses[0].ok && responses[1].ok) {
                const menuData = responses[0].data.data;
                const roleMenuData = responses[1].data.data;
                this.handleSetDataState(menuData, roleMenuData);
                this.setState((prevValue) => ({
                    ...prevValue,
                    masterMenuData: menuData,
                }));
            }
        } catch (error) {
            // TODO
        } finally {
            this.setState((prevValue) => ({...prevValue, loading: false}));
        }
    };

    handleSetDataState = async (menuData, roleMenuData) => {
        let menuPath = [];
        const traverseAndMap = (menuList) => {
            for (const menu of menuList) {
                // Initialize localExpand property for each menu item
                menu.localExpand = false;
                
                if (menu.children && !R.isEmpty(menu.children)) {
                    if (R.isNil(menu.parentId)) {
                        menuPath.length = 0;
                    }
                    menuPath.push(menu.id);
                    traverseAndMap(menu.children);
                } else {
                    const roleMenu = roleMenuData.find((role) => role.idMenu === menu.id);
                    menu.options = this.handleGenerateOptions(roleMenu);
                    menu.optionDisable = true;
                    if (!R.isNil(roleMenu)) {
                        menuPath.push(menu.id);
                        let index = 0;
                        const traverseAndExpand = (menuNodes) => {
                            for (const node of menuNodes) {
                                if (node.id === menuPath[index]) {
                                    index++;
                                    node.expanded = true;
                                    node.localExpand = true; // Set localExpand when expanding
                                    node.status = "ACTIVE";
                                    if (node.children && !R.isEmpty(node.children)) {
                                        traverseAndExpand(node.children);
                                    } else {
                                        if (menuPath.length === index) {
                                            node.optionDisable = false;
                                        }
                                    }
                                }
                            }
                        };

                        traverseAndExpand(menuData);
                    }

                    menuPath = menuPath.slice(0, 1);
                }
            }
        };

        traverseAndMap(menuData);
    };

    handleGenerateOptions = (roleMenu) => [
        {
            name: "C",
            checked: roleMenu ? roleMenu.createAccess : false,
        },
        {
            name: "U",
            checked: roleMenu ? roleMenu.updateAccess : false,
        },
        {
            name: "D",
            checked: roleMenu ? roleMenu.deleteAccess : false,
        },
    ];

    handleTreeCheckboxChange = (e, menuPath) => {
        const checked = e.target.checked;
        this.setState((prevValue) => {
            const menuData = [...prevValue.masterMenuData];
            const traverseAndUpdate = (menuList, index) => {
                if (index >= menuPath.length) return;


                const id = menuPath[index];
                for (const menu of menuList) {
                    if (menu.id === id) {
                        if (index === menuPath.length - 1) {
                            menu.status = checked ? Status.ACTIVE : Status.INACTIVE;
                            menu.localExpand = checked;
                            if (!menu.expanded && checked) {
                              menu.expanded = true;
                            }
                            
                            menu.optionDisable =
                                R.equals(menu.status, Status.INACTIVE) && !R.isEmpty(menu.options);
                            if (R.isNil(menu.parentId) || !R.isNil(menu.parentId)) {
                                traverseAndDelete(menu);
                            }
                        } else {
                            if (menu.children && !R.isEmpty(menu.children)) {
                                traverseAndUpdate(menu.children, index + 1);
                            }
                        }
                        break;
                    }
                }
            };

            const traverseAndDelete = (menu) => {
                if (menu.children && !R.isEmpty(menu.children)) {
                    for (const childMenu of menu.children) {
                        if (childMenu.children && !R.isEmpty(childMenu.children)) {
                            traverseAndDelete(childMenu);
                        }
                        if(childMenu.children.length===0 && childMenu.options.length===3){
                            childMenu.localExpand = checked
                            childMenu.expanded = checked;
                            childMenu.status = Status.ACTIVE;
                            childMenu.optionDisable = false
                        }

                        if (R.equals(childMenu.status, Status.ACTIVE) && !checked) {
                            childMenu.status = Status.INACTIVE;
                            // Don't collapse expanded state when unchecking parent
                            // childMenu.expanded = false;
                            // childMenu.localExpand = false; // Reset localExpand when deactivating
                            childMenu.optionDisable = true;
                        }
                    }
                }
            };

            traverseAndUpdate(menuData, 0);
            return {
                ...prevValue,
                masterMenuData: menuData,
            };
        });
    };

    handleCheckboxChange = (e, options, modifiedIndex, rowInfo) => {
        const menuPath = rowInfo.path;
        const newOptionsValue = options.map((option, idx) => {
            if (idx === modifiedIndex) {
                return {
                    ...option,
                    checked: e.target.checked,
                };
            }

            return option;
        });

        this.setState((prevState) => {
            const menuData = [...prevState.masterMenuData];
            const traverseAndUpdate = (menuList, index) => {
                if (index >= menuPath.length) return;

                const currentNode = menuPath[index];
                for (const menu of menuList) {
                    if (menu.id === currentNode) {
                        if (index === menuPath.length - 1) {
                            menu.options = newOptionsValue;
                        } else {
                            if (menu.children && !R.isEmpty(menu.children)) {
                                traverseAndUpdate(menu.children, index + 1);
                            }
                        }
                        break;
                    }
                }
            };

            traverseAndUpdate(menuData, 0);
            return {
                ...prevState,
                masterMenuData: menuData,
            };
        });
    };

    handleCopyMenuSetting = async () => {
        this.setState((prevValue) => ({...prevValue, loading: true}));
        const menuData = [...this.state.masterMenuData];
        const requestData = {
            idRole: this.props.data.id,
            listMenu: [],
        };

        const flattenList = (menuList) => {
            for (const menu of menuList) {
                if (R.isNil(menu.parentId)) {
                    flattenList(menu.children);
                } else {
                    if (!R.isNil(menu.parentId) && menu.children && !R.isEmpty(menu.children)) {
                        flattenList(menu.children);
                    }

                    const options = menu.options;
                    if (!R.isEmpty(options)) {
                        if (R.equals(menu.status, Status.ACTIVE)) {
                            const cudAccess = options.reduce(
                                (acc, obj) => {
                                    const accessMap = {
                                        C: "createAccess",
                                        D: "deleteAccess",
                                        U: "updateAccess",
                                    };

                                    acc[accessMap[obj.name]] = obj.checked;
                                    return acc;
                                },
                                {
                                    createAccess: false,
                                    deleteAccess: false,
                                    updateAccess: false,
                                }
                            );

                            const requestObj = {
                                idMenu: menu.id,
                                ...cudAccess,
                            };
                            requestData.listMenu.push(requestObj);
                        }
                    }
                }
            }
        };

        flattenList(menuData);
        let res = await fetchDataAsync({
            asyncFn: Api.create("NAGAMAS_AUTH").createRoleMenu,
            menuName: "Setting Hak Akses",
            setError: this.props.setError,
            args: requestData,
        });
        if (res.ok && res.data.status === HttpStatus.SUCCESS) {
            await this.props.triggerFetch();
            this.props.onClickClose();
        }
        this.setState((prevValue) => ({...prevValue, loading: false}));
    };

    handleDisplayCud = (node, rowInfo) => {
        if (!R.isNil(node.parentId)) {
            return (
                <FlexView
                    id={node.id}
                    key={node.id}
                    vAlignContent="center"
                    style={{
                        position: "fixed",
                        right: "30px",
                        gap: "10px",
                    }}
                >
                    {node.options.map((option, index) => (
                        <FlexView
                            id={index}
                            key={index}
                            vAlignContent="center"
                            style={{gap: "5px", fontSize: "20px"}}
                        >
                            <label>{option.name}</label>
                            <input
                                id={`input_checkbox_cud_${index}`}
                                type="checkbox"
                                disabled={node.optionDisable}
                                checked={option.checked}
                                onChange={(e) => this.handleCheckboxChange(e, node.options, index, rowInfo)}
                            />
                        </FlexView>
                    ))}
                </FlexView>
            );
        }

        return null;
    };

    render() {
        return (
            <>
                <SimpleModal
                    title="Menu"
                    visible={this.props.visible}
                    onClickClose={this.props.onClickClose}
                    content={
                        <ModalContainer>
                            <div style={{height: "600px"}}>
                                <SortableTree
                                    treeData={this.state.masterMenuData}
                                    getNodeKey={({node}) => node.id}
                                    canDrag={() => false}
                                    onChange={(treeData) => this.setState({masterMenuData: treeData})}
                                    nodeContentRenderer={(props) => {
                                        const {node, path, toggleChildrenVisibility, title} = props;
                                        return (
                                            <div key={props.node.id} style={{height: "100%"}}>
                                                <div>
                                                    <div>
                                                        <input
                                                            id={`input_checkbox_open_tree_${props.node.id}`}
                                                            type="checkbox"
                                                            style={{
                                                                position: "absolute",
                                                                left: "-29px",
                                                                top: "22px",
                                                                height: "18px",
                                                                width: "18px",
                                                            }}
                                                            checked={node.localExpand || false}
                                                            onChange={(e) => {
                                                                // toggleChildrenVisibility({node, path});
                                                                this.handleTreeCheckboxChange(e, path);
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                                <div 
                                                    className="rst__rowWrapper" 
                                                    style={{marginTop: "5px", cursor:"pointer",zIndex:10}}
                                                    onClick={(e) => {
                                                      if ( e.target.closest(".cud-checkbox") || e.target.type === "checkbox" || node?.children?.length === 0) {
                                                        return;
                                                      }
                                                      toggleChildrenVisibility({
                                                        node,
                                                        path,
                                                      });
                                                    }}
                                                >
                                                    <div className="rst__row">
                                                        <div className="rst__rowContents rst__rowContentsDragDisabled">
                                                            <div className="rst__rowLabel">
                                                                <span className="rst__rowTitle">{title}</span>
                                                            </div>
                                                            <div className="rst__rowToolbar"></div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        );
                                    }}
                                    generateNodeProps={(rowInfo) => {
                                        const {node} = rowInfo;
                                        return {
                                          title: (
                                            <FlexView
                                              id={node.id}
                                              key={node.id}
                                              vAlignContent="center"
                                              style={{ gap: "10px" }}
                                            >
                                              <span>{node.menuName}</span>
                                              <div
                                                className="cud-checkbox"
                                                onClick={(e) => e.stopPropagation()}
                                                style={{ cursor: "default",display: "flex", alignItems:'center',backgroundColor:'red' }}
                                              >
                                                {this.handleDisplayCud(node, rowInfo)}
                                              </div>
                                            </FlexView>
                                          ),
                                        };
                                    }}
                                />
                            </div>
                            <br/>
                            <div style={{textAlign: "right"}}>
                                <SimpleButton onClick={this.handleCopyMenuSetting}>Simpan</SimpleButton>
                            </div>
                        </ModalContainer>
                    }
                />
                {this.state.loading && <SimpleLoadingOverlay active={this.state.loading}/>}
            </>
        );
    }
}

export default AccessMenuSettingTree;